import { KEYWORDS } from '../core/actionNames';

const { SET_DATA } = KEYWORDS;

export function setData(data) {
    return {
        type: SET_DATA,
        data,
    };
}